import { INIT_NEW_CARGA, SET_NEW_CARGA } from "../../types/objetivos/cargaTypes";

export const setInitCargaObjOfi = () => ({ type: INIT_NEW_CARGA });

export const setCargaObjOfi = (prop:string, datasave: any) => ({ type: SET_NEW_CARGA, payload: {prop, datasave} });